import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http:HttpClient) { }

  public getDuplicationUsernameCnicCheck(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/checkDuplicateUserName', payload)
  }

  public registerUser(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/register', payload)
  }

  public getCountryByDialingCode(countryId): Observable<any>{
    return this.http.get(environment.BASE_URL_COMMON+'cmn/getCountryByDialingCodes/'+countryId)
  }

  public verifyContactAndSendCode(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/verifyContactAndSendCode',payload)
  }
}
